<button (click)="onToggle(); $event.stopPropagation()"
  class="cart-button group relative flex h-11 w-11 items-center justify-center rounded-full text-gray-600 transition-colors hover:bg-gray-100 hover:text-orange-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500"
  [ngClass]="{ 'bg-gray-100 text-orange-600': isOpen }"
  [attr.aria-label]="'Koszyk' + (cartCount ? ', pozycji: ' + cartCount : '')"
  [attr.aria-expanded]="isOpen">
  <svg class="h-[22px] w-[22px] transition-colors group-hover:text-orange-600"
    fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round"
      d="M3 3h2l.4 2M7 13h10l4-8H5.4m0 0L7 13m0 0l-2 8m2-8v8a2 2 0 002 2h6a2 2 0 002-2v-8" />
  </svg>

  <span *ngIf="cartCount > 0"
    class="cart-badge absolute -right-0.5 -top-0.5 z-10 flex h-[18px] min-w-[18px] items-center justify-center rounded-full border-2 border-white bg-orange-500 px-1 text-[10px] font-semibold leading-none text-white"
    aria-live="polite">
    {{ cartCount > 99 ? '99+' : cartCount }}
  </span>
</button>